import React, { useEffect, useState } from 'react';
import DataTable from "examples/Tables/DataTable";
import MDButton from "components/MDButton";
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import EditIcon from '@mui/icons-material/Edit';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import { updateResource } from './CRUD';
import { validarMateria } from './validaciones';
import { useAlerta } from "utils/alertas";
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 24,
  p: { xs: 2, sm: 3, md: 4 }, // padding responsive
  width: { xs: '90%', sm: 400, md: 500 }, // 🔥 clave
  maxHeight: '90vh', // evita que se salga de pantalla
  overflowY: 'auto', // scroll interno
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
};

export default function MateriasList() {
  const [materias, setMaterias] = useState([]);
  const [carreras, setCarreras] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [semestres, setSemestres] = useState([]);
  const [tipoPrograma, setTipoPrograma] = useState("");
  const [semestresFiltrados, setSemestresFiltrados] = useState([]);
  const [selectedSemestreId, setSelectedSemestreId] = useState('');
  const [asignacionesActuales, setAsignacionesActuales] = useState([]);
  let nombreNivel;
  const [editMateria, setEditMateria] = useState({ id: '', codigo: '', asignatura: '', semestre: '', horas: '', carrera_id: ''});
  const [errores, setErrores] = useState({});
  const [selectedCarreraId, setSelectedCarreraId] = useState('');
  const [openAsignacion, setOpenAsignacion] = useState(false);
  const [grupos, setGrupos] = useState([]);
  const [docentes, setDocentes] = useState([]);
  const [capacitaciones, setCapacitaciones] = useState([]);
  const [selectedModuloId, setSelectedModuloId] = useState('');
  const [programaTipo, setProgramaTipo] = useState("");
  const [programaId, setProgramaId] = useState("");
  const [openPrerequisitos, setOpenPrerequisitos] = useState(false);
  const [materiaActual, setMateriaActual] = useState(null);
  const [prerequisitos, setPrerequisitos] = useState([]);
  const [prerequisitosSeleccionados, setPrerequisitosSeleccionados] = useState([]);
  const [materiaNombre, setMateriaNombre] = useState("");
  const { mostrarAlerta } = useAlerta();

  const fetchSemestres = (tipo, programa_id) => {
    
    if (tipo === "c") {
      tipo= "carrera";
    }
    else
    {
      tipo = "capacitacion";
    }
    fetch(`${process.env.REACT_APP_API_URL}/semestre/${tipo}/${programa_id}`,{
      headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
    })
    .then((res) => res.json())
    .then((data)=> {
      const lista = Array.isArray(data.data) ? data.data : data;
      setSemestres(lista || []);
    })
    .catch((err)=>{
      console.error(err);
      setSemestres([]);
    });
  };
  const fetchSemestreCapacitacion = async (capacitacionId) => {
    const res = await fetch(
        `${process.env.REACT_APP_API_URL}/semestre/${capacitacionId}/capacitacion`,
        {
          headers:{
              Authorization:`Bearer ${token}`,
              Accept:"application/json"
          }
        }
    );

    const data = await res.json();

    setSelectedSemestreId(data.id);

    fetchGrupos(data.id);
  }

  const [asignacion, setAsignacion] = useState({
    grupo_id: "",
    docente_id: "",
    materia_id: ""
  });

  const handleOpenAsignacion = async (materia) => {
    setAsignacion({
      grupo_id: "",
      docente_id: "",
      materia_id: materia.id
    });
    setMateriaNombre(materia.asignatura);

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/materias/${materia.id}/asignaciones`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json"
          }
        }
      );

      const data = await res.json();
      setAsignacionesActuales(data);

    } catch (error) {
      console.error(error);
      setAsignacionesActuales([]);
    }

    setOpenAsignacion(true);
  };
  const asignacionesRows = asignacionesActuales.map((item) => ({
    grupo: item.grupo,
    docente: item.docente,
    accion: (
      <MDButton
        color="error"
        size="small"
        onClick={() => eliminarAsignacion(item.id)}
      >
        Eliminar
      </MDButton>
    )
  }));
  const eliminarAsignacion = async (id) => {
    if (!window.confirm("¿Eliminar asignación?")) return;

    try {
      await fetch(`${process.env.REACT_APP_API_URL}/asignacion/${id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      setAsignacionesActuales(prev =>
        prev.filter(item => item.id !== id)
      );

      mostrarAlerta("Asignación eliminada", "success");

    } catch (error) {
      console.error(error);
      mostrarAlerta("Error al eliminar", "error");
    }
  };
  const handleOpenPrerequisitos = async (materia) => {

    setMateriaActual(materia);

    try {

      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/materias/${materia.id}/prerequisitos-config`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      const data = await res.json();

      setPrerequisitos(data.materias || []);

      setPrerequisitosSeleccionados(data.seleccionados || []);

      setOpenPrerequisitos(true);

    } catch (error) {

      console.error(error);

    }

  };
  const handleClosePrerequisitos = () => {
    setOpenPrerequisitos(false);
  };
  const togglePrerequisito = (id) => {

    if (prerequisitosSeleccionados.includes(id)) {

      setPrerequisitosSeleccionados(
        prerequisitosSeleccionados.filter(p => p !== id)
      );

    } else {

      setPrerequisitosSeleccionados([
        ...prerequisitosSeleccionados,
        id
      ]);

    }

  };
  const handleSavePrerequisitos = async () => {

  try {

    await fetch(
      `${process.env.REACT_APP_API_URL}/materias/${materiaActual.id}/prerequisitos`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          prerequisitos: prerequisitosSeleccionados
        })
      }
    );

    handleClosePrerequisitos();
    mostrarAlerta("Prerequisito guardado correctamente","success");

  } catch (error) {

    console.error(error);
    mostrarAlerta("Ocurrio un error al guardar el prerequisito","error");
  }

};

  const handleCloseAsignacion = () => {
    setOpenAsignacion(false);
  };
  const handleSaveAsignacion = async () => {
    try {

      await fetch(`${process.env.REACT_APP_API_URL}/docente/asignacion`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify(asignacion)
      });
      console.log(asignacion);

      handleCloseAsignacion();
      mostrarAlerta("Docente asignado a grupo correctamente","success");

    } catch (error) {
      console.error(error);
      mostrarAlerta("Ocurrio un arror al asignar docente a grupo","error")
    }
  };
  // ------------------ FETCH ------------------
  const token = sessionStorage.getItem("access_token");

  const fetchMaterias = async () => {
    setLoading(true);
    if (!token) return setLoading(false);

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/materias`, {
        headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
      });
      if (!res.ok) throw new Error("Error al obtener materias");
      const data = await res.json();
      setMaterias(data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchCarreras = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/carreras`, {
        headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
      });
      if (!res.ok) throw new Error("Error al obtener carreras");
      const data = await res.json();
      setCarreras(data);
    } catch (err) {
      console.error(err);
    }
  };
    nombreNivel = programaTipo === "cap" ? "Semestre" : "Año";
  const fetchCapacitaciones = async () => {
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/modulos`, {
      headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
    });

    const data = await res.json();
    setCapacitaciones(Array.isArray(data) ? data : data.data || []);

  } catch (error) {
    console.error(error);
  }
};
const fetchDocentes = async () => {
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/docente`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json"
      }
    });

    const data = await res.json();
    setDocentes(data);

  } catch (error) {
    console.error(error);
  }
};

const fetchGrupos = async (semestreId) => {
  if (!semestreId) {
    setGrupos([]);
    return;
  }

    // Cambiamos el endpoint para pedir los grupos del Pensum en Laravel
    fetch(`${process.env.REACT_APP_API_URL}/grupos/${semestreId}/semestres`, {
      headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
    })
      .then((res) => res.json())
      .then((data) => {
        const lista = Array.isArray(data.data) ? data.data : data;
        setGrupos(lista || []);
      })
      .catch((err) => {
        console.error(err);
        setGrupos([]);
      });
};
  useEffect(() => {
    fetchMaterias();
    fetchCarreras();
    fetchCapacitaciones();
    fetchDocentes();
    fetchSemestres();
  }, []);
  

  // ------------------ MODAL ------------------
  const handleOpen = (materia) => {
    setEditMateria(
      materia
        ? {
            ...materia,
            semestre_id: materia.semestre_id || selectedSemestreId
          }
        : {
            id: '',
            codigo: '',
            asignatura: '',
            horas: '',
            semestre_id: selectedSemestreId,
            carrera_id: programaTipo === "c" ? programaId : null,
            capacitacion_id: programaTipo === "cap" ? programaId : null
          }
    );

    setErrores({});
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  const handleChange = (e) => setEditMateria({ ...editMateria, [e.target.name]: e.target.value });

  const handleSaveMateria = async () => {
    const erroresMateria = validarMateria(editMateria, materias);
    setErrores(erroresMateria);
    if (Object.keys(erroresMateria).length > 0) return;

    try {
      const action = editMateria.id ? 'update' : 'create';
      const url = action === 'create'
        ? `${process.env.REACT_APP_API_URL}/materias`
        : `${process.env.REACT_APP_API_URL}/materias/${editMateria.id}`;

      // 🏗️ Creamos el payload final mapeando los nombres que tu Backend espera
      const materiaFinal = {
        codigo: editMateria.codigo,
        asignatura: editMateria.asignatura,
        horas: parseInt(editMateria.horas),
        semestre_id: parseInt(
            editMateria.id
                ? editMateria.semestre_id
                : selectedSemestreId
        ),
      };

      if (editMateria.id) {
        materiaFinal.id = editMateria.id; // Si editamos, adjuntamos el ID de la materia
      }

      // ✅ MANDAMOS 'materiaFinal' (No 'editMateria')
      await updateResource(url, materiaFinal, action);

      mostrarAlerta(
        editMateria.id
          ? "Materia actualizada correctamente"
          : "Materia creada correctamente",
        "success"
      );

      fetchMaterias();
      handleClose();
    } catch (err) {
      mostrarAlerta("Error al guardar la materia", "error");
    }
  };

  // ------------------ ELIMINAR ------------------
  const handleDeleteMateria = async (id) => {
    if (!window.confirm("¿Deseas eliminar esta materia?")) return;
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/materias/${id}/eliminar-logico`, {
        method: "PUT",
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      });
      if (!res.ok) throw new Error("Error al eliminar");
      fetchMaterias();
    } catch (err) {
      console.error(err);
    }
  };

  const handleProgramaChange = (e) => {
    const value = e.target.value;
    setSelectedCarreraId(value);
    setSelectedSemestreId(""); 

    if (!value) {
      setProgramaTipo("");
      setProgramaId("");
      return;
    }

    let [tipo, id] = value.split("-");
    setProgramaTipo(tipo);
    setProgramaId(id);
    fetchSemestres(tipo,id);


    tipo = tipo === "c" ? "carrera" : tipo === "cap" ? "capacitacion" : tipo;
  };

  // ------------------ TABLA ------------------
  const materiasFiltradas = materias.filter(m => {
    // Si no ha elegido pensum, no muestra nada en la tabla
    if (!selectedSemestreId) return false;

    // Solo mostramos las materias que pertenecen a este pensum_id
    return String(m.semestre_id) === String(selectedSemestreId);
  });

  // Quítale el "const" en la línea 365
  

  const materiasPorNivel = materiasFiltradas.reduce((acc, m) => {
    const nivel = m.nivel; // Usando tu columna 'nivel' de la migracion
    if (!acc[nivel]) acc[nivel] = [];
    acc[nivel].push(m);
    return acc;
  }, {});
  const columnas = Object.keys(materiasPorNivel)
    .sort((a, b) => a - b)
    .map(nivel => ({

      Header: `Materias`,

      accessor: nivel,

      Cell: ({ row }) => {

        const materia = row.original[nivel];

        if (!materia) return null;

        return (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <span>{materia.asignatura}</span>

            <MDButton size="small" color="info" onClick={() => handleOpen(materia)}>
              <EditIcon sx={{ fontSize: 16 }} />
            </MDButton>

            <MDButton size="small" color="error" onClick={() => handleDeleteMateria(materia.id)}>
              <DeleteIcon sx={{ fontSize: 16 }} />
            </MDButton>

            <MDButton size="small" color="warning" onClick={() => handleOpenAsignacion(materia)}>
              <AssignmentIndIcon sx={{ fontSize: 16 }} />
            </MDButton>
            <MDButton 
              size="small" 
              color="dark" 
              onClick={() => handleOpenPrerequisitos(materia)}
            >
              PR
            </MDButton>

          </Box>
        );
      }

    }));

  const maxFilas = Math.max(...Object.values(materiasPorNivel).map(arr => arr.length), 0);
  const filas = Array.from({ length: maxFilas }).map((_, idx) => {
    const fila = {};
    for (const sem in materiasPorNivel) fila[sem] = materiasPorNivel[sem][idx] || null;
    return fila;
  });

  if (loading) return <div>Cargando materias...</div>;

  return (
    <Box sx={{ p: 2 }}>
      <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
        <TextField
          select
          label="Tipo de programa"
          fullWidth
          value={tipoPrograma}
          onChange={(e) => {
            setTipoPrograma(e.target.value);

            setSelectedCarreraId("");
            setSelectedSemestreId("");
            setSelectedModuloId("");
            setProgramaId("");
            setProgramaTipo("");
          }}
          SelectProps={{ native: true }}
        >
          <option value=""></option>
          <option value="carrera">Carrera</option>
          <option value="capacitacion">Capacitación</option>
        </TextField>
        {tipoPrograma === "carrera" && (
          <>
            <TextField
              select
              label="Carrera"
              fullWidth
              value={selectedCarreraId}
              onChange={handleProgramaChange}
              SelectProps={{ native: true }}
            >

              <option value=""></option>
                {carreras.map(c => (
                  <option key={`c-${c.id}`} value={`c-${c.id}`}>
                    {c.nombre}
                  </option>
                ))}
            </TextField>
            <TextField
              select
              label="Semestre"
              fullWidth
              value={selectedSemestreId}
              onChange={(e) => {
                const id = e.target.value;
                setSelectedSemestreId(id);
                fetchGrupos(id);
              }}
              SelectProps={{ native: true }}
            >
              <option value=""></option>

              {semestres.map(s => (
                <option key={s.id} value={s.id}>
                  {s.nombre} {s.numero}
                </option>
              ))}
            </TextField>
          </>
        )}
        {tipoPrograma === "capacitacion" && (
          <TextField
            select
            label="Capacitación"
            fullWidth
            value={selectedModuloId}
            onChange={(e) => {
              const id = e.target.value;

              setSelectedModuloId(id);

              setProgramaTipo("cap");
              setProgramaId(id);
              fetchSemestreCapacitacion(id);
            }}
            SelectProps={{ native: true }}
          >
            <option value=""></option>

            {capacitaciones.map(c => (
              <option key={c.id} value={c.id}>
                {c.nombre}
              </option>
            ))}
          </TextField>
        )}
        <Tooltip title="Añadir materia">
          <MDButton color="success" onClick={() => handleOpen(null)} disabled={!selectedSemestreId}>
            <AddCircleIcon />
          </MDButton>
        </Tooltip>
      </Box>

      <DataTable
        table={{ columns: columnas, rows: filas }}
        entriesPerPage={{ defaultValue: 10, entries: [5, 10, 15, 20] }}
        showTotalEntries
        pagination={{ variant: 'gradient', color: 'info' }}
        isSorted
        noEndBorder={false}
      />

      <Modal open={open} onClose={handleClose}>
        <Box sx={modalStyle}>
          <Typography variant="h6">
            {editMateria.id ? "Actualizar Materia" : "Agregar Materia"}
          </Typography>

          <TextField
            label="Código"
            name="codigo"
            fullWidth
            value={editMateria.codigo}
            onChange={handleChange}
            error={!!errores.codigo}
            helperText={errores.codigo}
          />
          <TextField
            label="Asignatura"
            name="asignatura"
            fullWidth
            value={editMateria.asignatura}
            onChange={handleChange}
            error={!!errores.asignatura}
            helperText={errores.asignatura}
          />
          {editMateria.id && programaTipo === "c" && (
            <TextField
              select
              label="Semestre"
              name="semestre_id"
              fullWidth
              value={editMateria.semestre_id || ""}
              onChange={handleChange}
              SelectProps={{ native: true }}
            >
              <option value=""></option>

              {semestres.map((s) => (
                <option key={s.id} value={s.id}>
                  {s.nombre} {s.numero}
                </option>
              ))}
            </TextField>
          )}
          <TextField
            label="Horas"
            name="horas"
            type="number"
            fullWidth
            value={editMateria.horas}
            onChange={handleChange}
            error={!!errores.horas}
            helperText={errores.horas}
          />

          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 2 }}>
            <MDButton color="info" onClick={handleSaveMateria}>
              {editMateria.id ? "Actualizar" : "Guardar"}
            </MDButton>
            <MDButton color="secondary" onClick={handleClose}>
              Cerrar
            </MDButton>
          </Box>
        </Box>
      </Modal>
      <Modal open={openAsignacion} onClose={handleCloseAsignacion}>
        <Box sx={modalStyle}>

          <Typography variant="h6">
            Asignaciones de {materiaNombre}
          </Typography>

           <DataTable
            table={{
              columns: [
                { Header: "Grupo", accessor: "grupo" },
                { Header: "Docente", accessor: "docente" },
                { Header: "Acción", accessor: "accion" }
              ],
              rows: asignacionesRows
            }}
            entriesPerPage={false}
            showTotalEntries={false}
          />

          <TextField
            select
            label="Grupo"
            fullWidth
            value={asignacion.grupo_id}
            onChange={(e) =>
              setAsignacion({ ...asignacion, grupo_id: e.target.value })
            }
            SelectProps={{ native: true }}
          >
            <option value=""></option>
            {grupos.map(g => (
              <option key={g.id} value={g.id}>
                {g.nombre}
              </option>
            ))} 
          </TextField>

          <TextField
            select
            label="Docente"
            fullWidth
            value={asignacion.docente_id}
            onChange={(e) =>
              setAsignacion({ ...asignacion, docente_id: e.target.value })
            }
            SelectProps={{ native: true }}
          >
            <option value=""></option>
            {docentes.map(d => (
              <option key={d.id} value={d.id}>
                {d.name}
              </option>
            ))}
          </TextField>

          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>

            <MDButton color="info" onClick={handleSaveAsignacion}>
              Guardar
            </MDButton>

            <MDButton color="secondary" onClick={handleCloseAsignacion}>
              Cancelar
            </MDButton>

          </Box>

        </Box>
      </Modal>
      <Modal open={openPrerequisitos} onClose={handleClosePrerequisitos}>
        <Box sx={{ ...modalStyle}}>

          <Typography variant="h6">
            Prerrequisitos de {materiaActual?.asignatura}
          </Typography>

          <Box sx={{
            maxHeight: 300,
            overflowY: "auto",
            display: "flex",
            flexDirection: "column",
            gap: 1
          }}>

            {prerequisitos.map(m => (
                <Box
                  key={m.id}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1
                  }}
                >

                  <input
                    type="checkbox"
                    checked={prerequisitosSeleccionados?.includes(m.id) || false}
                    onChange={() => togglePrerequisito(m.id)}
                  />

                  <Typography>
                    {m.asignatura}
                  </Typography>

                </Box>

              ))}
          </Box>

          <Box sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 2,
            mt: 2
          }}>

            <MDButton
              color="info"
              onClick={handleSavePrerequisitos}
            >
              Guardar
            </MDButton>

            <MDButton
              color="secondary"
              onClick={handleClosePrerequisitos}
            >
              Cancelar
            </MDButton>

          </Box>

        </Box>
      </Modal>
    </Box>
    
  );
}
